import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from './plugins/vuetify';
import vueI18n from "./plugins/vueI18n";
import axios from "axios";
import VueResize from 'vue-resize';
import Echo from 'laravel-echo';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import { getType } from "./assets/js/mcn-helpers";
import './assets/css/tailwind.css';
//import './assets/css/font.css'

Vue.config.productionTip = false;
Vue.config.silent = true;
//Vue.config.devtools = false

Vue.use(VueResize);
Array.prototype.first = function () {
  return this === null || this === void 0 ? void 0 : this[0];
};
Array.prototype.last = function () {
  return this === null || this === void 0 ? void 0 : this[(this === null || this === void 0 ? void 0 : this.length) - 1];
};
Function.prototype.isFunction = function (v) {
  return getType(v) === 'Function';
};
window.Pusher = require('pusher-js');
window.Echo = new Echo({
  broadcaster: 'pusher',
  key: 'effc6939649abd90db30',
  cluster: 'eu',
  forceTls: true,
  disableStats: true,
  encrypted: true,
  authorizer: (channel, options) => {
    return {
      authorize: async (socketId, callback) => {
        axios.post([process.env.VUE_APP_API_BASE_URL, 'broadcasting/auth'].join(''), {
          socket_id: socketId,
          channel_name: channel.name
        }, {
          headers: {
            'Authorization': `Bearer ${store.getters.getAuthToken}`
          }
        }).then(response => {
          callback(false, response.data);
        }).catch(error => {
          callback(true, error);
        });
      }
    };
  }
});
new Vue({
  i18n: vueI18n,
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");